import * as React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';

import { client } from '../client';
import {ReactElement} from "react";

export const GraphQLProvider: React.FC<{children?: ReactElement}> = ({ children }) => (
  <ApolloProvider client={client} >{children}</ApolloProvider>
);
